import { render, staticRenderFns } from "./LiveClass.vue?vue&type=template&id=076dffd4&"
import script from "./LiveClass.vue?vue&type=script&lang=js&"
export * from "./LiveClass.vue?vue&type=script&lang=js&"
import style0 from "./LiveClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LiveClass.vue"
export default component.exports